export enum API_SERVICE {
  POST = "POST_SERVICE_API",
  USER = "USER_SERVICE_API",
}
